import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { Link } from '@atlassian/help-center-common-component/analytics/link';

interface HelpObjectProps {
    width?: number;
}

export const StyledHelpObject = styled.div<HelpObjectProps>`
    line-height: ${grid.multiple(3).px};
    display: flex;
    margin: ${token('space.100', '8px')} ${token('space.0', '0px')};
`;

export const ImageContainer = styled.div<HelpObjectProps>`
    height: ${grid.multiple(3).px};
    width: ${grid.multiple(3).px};
    margin-right: ${token('space.100', '8px')};
    flex-shrink: 0;
`;

export const Title = styled.div<{ showRegularCursor?: boolean }>`
    white-space: nowrap;
    width: 100%;
    align-self: center;
    color: ${token('color.text', colors.N800)};
    cursor: ${({ showRegularCursor = false }) => (showRegularCursor ? 'inherit' : 'pointer')};
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const StyledLink = styled(Link)`
    overflow: hidden;
`;
